export const localDate = (date) => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
export const dayDate = (value) => new Date(`${value}T12:00:00`);
export const addDays = (date, days) => {const next = new Date(date);next.setDate(next.getDate()+days);return next;};
export const monday = (date) => addDays(date, -(date.getDay()+6)%7);
export function viewDays(selected, view) {
  if(view === 'day')return [selected];
  if(view === 'week')return Array.from({length:7},(_,i)=>addDays(monday(selected),i));
  const first = new Date(selected.getFullYear(),selected.getMonth(),1,12);
  return Array.from({length:42},(_,i)=>addDays(monday(first),i));
}
export function onDay(entry,date) {
  const key=localDate(date);
  if(entry.all_day_date)return entry.all_day_date===key;
  if(!entry.start_at)return false;
  const start=new Date(`${key}T00:00:00`), end=addDays(start,1);
  return new Date(entry.start_at)<end && (entry.end_at ? new Date(entry.end_at)>start : new Date(entry.start_at)>=start);
}
export const isInbox = entry => !entry.start_at && !entry.all_day_date;
export const contentFields = ({title,kind,notes,location,start_at,end_at,all_day_date,completed,grants}) => ({title,kind,notes,location,start_at,end_at,all_day_date,completed,grants});
export function draftFor(entry, selected) {
  const date=entry?.start_at ? new Date(entry.start_at) : null;
  const time=d=>`${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
  return {...(entry || {}), title:entry?.title||'',kind:entry?.kind||'event',notes:entry?.notes||'',location:entry?.location||'',
    scheduled:entry ? !isInbox(entry) : true, allDay:!!entry?.all_day_date,
    date:entry?.all_day_date || (date?localDate(date):localDate(selected)), time:date?time(date):'09:00',
    endDate:entry?.end_at?localDate(new Date(entry.end_at)):(date?localDate(date):localDate(selected)),
    endTime:entry?.end_at?time(new Date(entry.end_at)):'10:00',completed:entry?.completed||false,grants:entry?.grants||[],category_id:entry?.category_id||''};
}
export function payloadFor(draft) {
  let start_at=null,end_at=null,all_day_date=null;
  if(draft.scheduled){
    if(!/^\d{4}-\d{2}-\d{2}$/.test(draft.date))throw new Error('Choose a date.');
    if(draft.allDay)all_day_date=draft.date;
    else {
      const start=new Date(`${draft.date}T${draft.time}`);
      if(!Number.isFinite(start.getTime()))throw new Error('Choose a start time.');
      const actual=`${String(start.getHours()).padStart(2,'0')}:${String(start.getMinutes()).padStart(2,'0')}`;
      if(actual!==draft.time)throw new Error('That time does not exist because the clocks change. Choose another time.');
      start_at=start.toISOString();
      if(draft.kind==='event'){
        const end=new Date(`${draft.endDate}T${draft.endTime}`);
        if(!Number.isFinite(end.getTime())||end<=start)throw new Error('End must be after start.');
        end_at=end.toISOString();
      }
    }
  }
  if(!draft.title.trim())throw new Error('Give this entry a title.');
  return {title:draft.title.trim(),kind:draft.kind,notes:draft.notes,location:draft.location,start_at,end_at,all_day_date,
    completed:draft.kind==='task'&&draft.completed,grants:draft.grants};
}
